import _ from 'underscore';

import Choices from 'choices.js/public/assets/scripts/choices.min.js';
import 'choices.js/public/assets/styles/choices.min.css';

import { NodeType} from './rules.js';

import Point from './point.js';

var menuTemplate = require("../../../../templates/point.handlebars");

const POINT = "location";


export default class PointMenu {

	constructor(api, siteData) {
    	this.name = 'PointMenu';
        this.api = api;
        this.siteData = siteData;
        this.selectedFeature;
        this.selectedPoint;
        this.rule;
        this.menu;
        this.editMode = false;
        this.editNode;
        this.keywords = [];
  	}

  	toString() {
        return this.name;
    }


    initMenu(){
        $("#point-body").append(menuTemplate);
        var _this = this;

        _this.keywords = [];
        _(_this.siteData.keywords).each(function (keyword) {
            _this.keywords.push(keyword.toLowerCase());
        });
        
        this.categoryDD = new Choices('#category-dropdown', {
              choices : this.siteData.categories,
              itemSelectText: 'Click to select'
        });

        

        $( "#remove-point" ).bind( "click", function(event) {
            event.preventDefault();
            $("#selected-point").toggle();
            $("#confirm-delete").toggle();
            $("#confirmback-drop").toggle();
        });

        $("#cancel-del-cnf").bind("click", function(event) {
            $("#confirm-delete").toggle();
            $("#selected-point").toggle();
            $("#confirmback-drop").toggle();
        });

        $("#delete-cnf").bind("click", function(event) {
            $("#confirm-delete").toggle();
            $("#selected-point").toggle();
            $("#confirmback-drop").toggle();
            _this.removePoint();
        });


        $( "#edit-point" ).bind( "click", function(event) {
            event.preventDefault();
            _this.editMode = true;
            _this.editPoint();
        });
        

        $( "#point-cancel" ).bind( "click", function(event) {
            event.preventDefault();
            _this.editMode = false;
            _this.cancelAddPoint();
        });

        $( "#point-save" ).bind( "click", function(event) {
            event.preventDefault();
            _this.savePoint();
        });
         
        $("#selected-point").hide(); // Hide the selected point section -- need conditon check here 
        $("#confirm-delete").hide(); // Hide confirmation box
        $("#confirmback-drop").hide();

    }

    onEditNode(){
        $("#point-cancel").show(); // Show cancel option on form
        $("#selected-point").show(); // Show point selected
        $("#selected-point-name").text(this.selectedPoint.name);
        $("#pointManuallySection").hide();

        // populate form data 
        this.configRuleSection();
        $("#InputPointName").val(this.selectedPoint.name);
        $("#InputPointDescription").val(this.selectedPoint.description);
        $("#InputPointNameAr").val(this.selectedPoint.name_ar);
        $("#InputPointDescriptionAr").val(this.selectedPoint.description_ar);
        // if(this.selectedPoint.step) $("#InputPointStep").prop('checked', true);
        $("#visible").prop('checked', this.selectedPoint.visible);
        $("#searchable").prop('checked', this.selectedPoint.searchable);
        $("#clickable").prop('checked', this.selectedPoint.clickable);
        this.categoryDD.setChoiceByValue(this.selectedPoint.category);
        this.editNode = this.selectedPoint.name;
        $( "#edit-point" ).show();
        this.configRuleSection();
    }

    async savePoint(){
        var props = {
            onserver : false,
            name : $("#InputPointName").val(),
            name_ar : $("#InputPointNameAr").val(),
            description : $("#InputPointDescription").val(),
            description_ar : $("#InputPointDescriptionAr").val(),
            category :this.categoryDD.getValue().value,
            label : this.categoryDD.getValue().label,
            visible : $("#visible").is(":checked"),
            searchable : $("#searchable").is(":checked"),
            clickable : $("#clickable").is(":checked")
        };
        
        let point =  new Point(props);
        var errors = point.validate();


        if(!errors){
            if(this.keywords.includes(point.getName().toLowerCase())){
                $( ".validation.point-name" ).html("<p>"+point.getName()+" is reserved keyword<p>" );
                $( '.validation.point-name' ).parent().addClass('validation-beco');
                return;
            }

            if(this.editMode && this.editNode == point.getName()){
                this.editNode = '';
            }else if(this.menu.isPointExist(point.getName())){
                $( ".validation.point-name" ).html("<p>"+point.getName()+" already exist in this floor<p>" );
                $( '.validation.point-name' ).parent().addClass('validation-beco');
                return;
            }else if(this.editMode){
                this.menu.removePoint(this.editNode);
            }

            this.selectedPoint = point;
            $("#selected-point").show(); // Show point selected
            $("#pointManuallySection").slideToggle(500); // Hide point add form
            $("#selected-point-name").text(this.selectedPoint.name);
            $( "#edit-point" ).show();
            this.configRuleSection();
            this.menu.addPoint(this.selectedPoint.name);
            

        } else {

            if(errors && errors['name']){
                $( ".validation.point-name" ).html("<p>"+errors['name'].toString()+"<p>" );
                $( '.validation.point-name' ).parent().addClass('validation-beco');
            }else {
                $( ".validation.point-name p" ).remove();
                $( '.validation.point-name' ).parent().removeClass('validation-beco');
            }

            if(errors && errors['category']){
                $( ".validation.category-sec" ).html("<p>"+errors['category'].toString()+"<p>");
                $( '.validation.category-sec' ).parent().addClass('validation-beco');
            }else {
                $( ".validation.category-sec p" ).remove();
                $( '.validation.category-sec' ).parent().removeClass('validation-beco');
            }

            if(errors && errors['description']){
                $( ".validation.point-description" ).html("<p>"+errors['description'].toString()+"<p>");
                $( '.validation.point-description' ).parent().addClass('validation-beco');
            }else {
                $( ".validation.point-description p" ).remove();
                $( '.validation.point-description' ).parent().removeClass('validation-beco');
            }

            if(errors && errors['name_ar']){
                $( ".validation.point-name-ar" ).html("<p>"+errors['name_ar'].toString()+"<p>");
                $( '.validation.point-name-ar' ).parent().addClass('validation-beco');
            }else {
                $( ".validation.point-name-ar p" ).remove();
                $( '.validation.point-name-ar' ).parent().removeClass('validation-beco');
            }


            if(errors && errors['description_ar']){
                $( ".validation.point-description-ar" ).html("<p>"+errors['description_ar'].toString()+"<p>");
                $( '.validation.point-description-ar' ).parent().addClass('validation-beco');
            }else {
                $( ".validation.point-description-ar p" ).remove();
                $( '.validation.point-description-ar' ).parent().removeClass('validation-beco');
            }


            if(errors && (errors['name'] || errors['description'])){
                $( '#nav-eng-tab' ).addClass('active');
                $( '#nav-ar-tab' ).removeClass('active');
                
                $( '#point-eng' ).addClass('show active');
                $( '#point-arab' ).removeClass('show active');
            } else {
                $( '#nav-ar-tab' ).addClass('active');
                $( '#nav-eng-tab' ).removeClass('active');

                $( '#point-eng' ).removeClass('show active');
                $( '#point-arab' ).addClass('show active');
            }
        }
        
    }

    cancelAddPoint(){
        $("#pointManuallySection").slideToggle(500);
        $("#selected-point").show();
    }

    
    getMenu() {
        return this;
    }

    open(feature, rule, menu){
        this.initMenu();
        this.selectedFeature = feature;
        this.rule = rule;
        this.menu = menu;
        if(feature.getProperties() && feature.getProperties().location){
            this.selectedPoint = this.getOrCreatePoint(feature.getProperties().location);
            this.onEditNode();
        }
        this.editMode = false;
    }

    save(){
        let props = {};

        if(this.selectedFeature) props['location'] = this.selectedPoint;
        this.selectedFeature.setProperties(props);

        var type;
        if(this.selectedPoint && this.selectedPoint.isLift()){
            type = NodeType.LIFT;
        }

        this.selectedFeature = null;
        this.selectedPoint = null;
        $("#point-side-menu").remove();

        return type;
    }

    configRuleSection(){
        if(this.selectedPoint && this.selectedPoint.isLift()){
            this.rule.showLifteRule();
            this.rule.hideEscalatorRule();
            this.rule.hideEmptyView();
        } else {
            this.rule.hideLifteRule();
            this.rule.hideEscalatorRule();
            this.rule.showEmptyView();
        }
    }

    removePoint(){
        if(this.selectedPoint){
            this.menu.removePoint(this.selectedPoint.name);
            this.selectedPoint = null;
            $("#point-cancel").hide();
            $("#pointManuallySection").show();
            // If selected point is not in server show the add point form else the search

            $("#selected-point-name").text(""); // Reset the point name
            $("#selected-point").hide(); // Hide point selected\

            $("#InputPointName").val(""); // Reset textbox value
            this.configRuleSection();
            
        }
    }

    editPoint(){
        if(this.selectedPoint){
            $("#selected-point").hide(); // Hide point selected
            $("#pointManuallySection").slideToggle(500);
            $("#selected-point-name").text(this.selectedPoint.name);
            $("#InputPointName").val(this.selectedPoint.name);
            $("#InputPointDescription").val(this.selectedPoint.description);
            $("#InputPointNameAr").val(this.selectedPoint.name_ar);
            $("#InputPointDescriptionAr").val(this.selectedPoint.description_ar);
            this.editNode = this.selectedPoint.name;
            this.configRuleSection();
        }
    }
    

    static get getPointVariable() {
        return POINT;
    }

    getOrCreatePoint(params){
        console.log(params);
        var props = {
            category : params.category,
            visible : params.visible,
            searchable : params.searchable,
            clickable : params.clickable,
            name : params.name,
            name_ar : params.name_ar,
            description : params.description,
            description_ar : params.description_ar,
            label : params.categoryLabel
        };

        let point =  new Point(props);

        return point;
    }


    
}